import { render, staticRenderFns } from "./StaffCreate.vue?vue&type=template&id=3031375a"
import script from "./StaffCreate.vue?vue&type=script&lang=js"
export * from "./StaffCreate.vue?vue&type=script&lang=js"
import style0 from "./StaffCreate.vue?vue&type=style&index=0&id=3031375a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports